import React, { useEffect, useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import {
  getUrlDetailsObj,
  getTabType,
} from "../../../../../services/commonService";

export default function BusinessSegmentStructure({
  businessSegmentStructure = {},
}) {
  const [segmentsData, setSegmentsData] = useState([]);
  const [activeTab, setActiveTab] = useState(0);
  const [activeTabContent, setActiveTabContent] = useState(null);
  const [loading, setLoading] = useState(true);

  const pageParsedData = getUrlDetailsObj(useLocation, useParams);
  pageParsedData.query_params = { tab: "overview" };
  const tab_name = getTabType("overview") || "";

  const set_active_tab = (index) => {
    setActiveTab(index);
    setActiveTabContent(segmentsData[index]);
  };

  useEffect(() => {
    // Extract the segment fields from the structure
    const fields = businessSegmentStructure?.[0]?.response?.fields || {};
    const segmentsArray = Object.values(fields);

    setSegmentsData(segmentsArray);
    if (segmentsArray.length > 0) {
      setActiveTab(0);
      setActiveTabContent(segmentsArray[0]);
    }
    setLoading(false);
  }, [businessSegmentStructure]);

  // if (!loading && segmentsData.length === 0) {
  //   return null;
  // }

  return (
    <div className="business_seg_structure_wrapper">
      <div className="head_top">
        <h5 className="main_head">Business Segment Structure</h5>
      </div>

      <div className="d-flex vertical_tab_conversation">
        {/* Vertical Tabs */}
        <div
          className="nav flex-column nav-pills vertical_tab_conversation_left"
          id="v-pills-tab"
          role="tablist"
          aria-orientation="vertical"
        >
          {segmentsData.map((segment, i) => (
            <button
              onClick={() => set_active_tab(i)}
              key={i}
              className={`nav-link ${activeTab === i ? "active" : ""}`}
              id={`v-pills-tab-${i}`}
              type="button"
              role="tab"
              aria-selected={activeTab === i}
            >
              {segment.segment_name}
            </button>
          ))}
        </div>

        {/* Tab Content */}
        <div className="tab-content" id="v-pills-tabContent">
          {activeTabContent && (
            <div
              className="tab-pane fade show active custom_tab_pane"
              id={`v-pills-tabpane-${activeTab}`}
              role="tabpanel"
            >
              <div className="vertical_tab_conversation_right">
                <h5 className="head">{activeTabContent.segment_name}</h5>
                <ul className="list_vertical_tab">
                  {activeTabContent.products_solutions?.map((product, i) => (
                    <li key={i} className="list_tabs">
                      <i className="fa fa-chevron-right" aria-hidden="true"></i>{" "}
                      {product}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
